import { render, staticRenderFns } from "./FrzChamberDetailLosses.vue?vue&type=template&id=6ca01c5a"
import script from "./FrzChamberDetailLosses.vue?vue&type=script&lang=js"
export * from "./FrzChamberDetailLosses.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports